<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row>
      <b-col cols="12" md="8">
        <div class="margin-lateral">
          <h4 class="color-secundary mb-4">{{ intro }}</h4>
          <div class="text-justify">
            <div v-html="recomendacion" style="padding-right: 11%"></div>
          </div>
          <form @submit.prevent="cargue" id="cargue" style="padding-right: 13%">
            <b-form-file
              ref="archivo"
              required
              size="md"
              placeholder="Selecione un archivo"
              browse-text="Anexar"
              drop-placeholder="Suelte los archivos aqui...."
              :disabled="loading"
              class="mt-2"
              :accept="tipo_archivo ? tipo_archivo : '.txt'"
              :multiple="multiple ? multiple : false"
            >
              <!-- style="padding-right: 80px;" -->
              <template slot="file-name" slot-scope="{ names }">
                <b-badge v-if="names.length > 0" variant="dark" class="ml-1"
                  >{{ names[0] }} | {{ names.length }} Archivo(s)
                  seleccionado(s)</b-badge
                >
              </template>
            </b-form-file>
            <br />
            <br />
            <b-form-group
              label="Total disponible a transferir"
              label-for="disponible"
              :label-cols="12"
            >
              <b-form-input
                id="disponible"
                type="text"
                v-model="disponible"
                placeholder="Disponible total"
                @click="abrirDisponible"
                :disabled="!modal_disponible"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Seleccione un intermediario"
              label-for="disponible"
              :label-cols="12"
              v-if="this.bancos.length > 0"
            >
              <select
                class="form-control"
                id="datos_bancos"
                v-model="comprador"
                required
              >
                <option :value="null">Intermediarios</option>
                <option
                  v-for="banco in this.bancos"
                  :key="banco.nit"
                  :value="banco.nit"
                >
                  {{ banco.nombre }}
                </option>
              </select>
            </b-form-group>

            <!--b-form-group
              label="Escriba la modalidad de la venta"
              label-for="modalidad"
              :label-cols="12"
            >
              <b-form-input
                id="modalidad"
                type="text"
                v-model="modalidad"
                placeholder="Modalidad"
                required
              ></b-form-input>
            </b-form-group-->

            <b-alert
              show
              dismissible
              fade
              variant="primary"
              v-if="uploadResponse"
              class="mt-4"
              @dismissed="showDismissibleAlertSuccess = false"
            >
              <div class="text-center titulo-alerta-succes">¡Alerta!</div>
              {{ uploadResponse.mensaje }}
              <ul>
                <li
                  v-for="(
                    value, prerequisito, index
                  ) in uploadResponse.prerequisitos"
                  :key="index"
                >
                  {{ prerequisito }}
                  <ul>
                    <li v-for="(_value, cargue, _index) in value" :key="_index">
                      {{ _value }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>

            <b-alert
              show
              dismissible
              fade
              variant="danger"
              v-if="uploadRespnseError"
              class="mt-4"
              @dismissed="showDismissibleAlertError = false"
            >
              <div class="text-center titulo-alerta-danger">¡Alerta!</div>
              <ul>
                <li
                  v-for="(value, error, index) in uploadRespnseError"
                  :key="index"
                >
                  {{ error }}
                  <ul>
                    <li
                      v-for="(_value, archivo, _index) in value"
                      :key="_index"
                    >
                      {{ _value[0] }}
                    </li>
                  </ul>
                </li>
              </ul>
            </b-alert>

            <div class="mt-3 text-right">
              <img
                v-if="this.loading"
                class="loading"
                src="@/assets/images/loader.gif"
                alt
              />
              <!--b-button type="button" @click="limpiarInputReset" variant="outline-primary" :disabled="loading" class="ml-1">Limpiar</b-button-->
              <b-button
                type="submit"
                :disabled="this.loading || this.bancos.length == 0"
                class="ml-1 button-carga"
                >Enviar</b-button
              >
            </div>
          </form>
        </div>
      </b-col>
      <!-- Panel Derecho -->
      <BannerRight />
    </b-row>
    <b-modal
      id="modal-1"
      title="Selecciones los valores a transferir"
      hide-footer
      size="xl"
    >
      <div class="m-3">
        <div class>
          <div class="container">
            <br />
            <div class="form-group">
              <div v-for="items in this.productos" :key="items.id">
                <h4>Nombre del producto</h4>
                <p v-text="items.producto ? items.producto : items.alias"></p>

                <h4>Disponible del producto</h4>
                <p v-text="items.disponible_format"></p>

                <h4>Disponible a transferir</h4>
                <b-form-group>
                  <b-form-input
                    class="form-control"
                    id="disponible"
                    type="number"
                    v-model="items.transf"
                    min="0"
                    step="1"
                    :max="items.disponible"
                    required
                  ></b-form-input>

                  <br />
                </b-form-group>
              </div>
              <b-button
                type="button"
                variant="primary"
                @click="guardarDisponible"
                :disabled="loading"
                class="ml-1"
                >Guardar</b-button
              >
            </div>
            <br />
            &nbsp;
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import { mapGetters } from "vuex";

import Vue from "vue";

export default {
  name: "SubirArchivo",
  data: () => {
    return {
      modal_disponible: false,
      files: new FormData(),
      uploadResponse: null,
      uploadRespnseError: null,
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      showDismissibleAlertSuccess: false,
      showDismissibleAlertError: false,
      text: "",
      intro: "En este espacio podrás cargar la venta de cartera",
      recomendacion: `<b>Para que sea un cargue exitoso le recomendamos:</b><br><br>
                <b>1. Nombre del archivo:</b> debe tener el siguiente formato <b>vc_nit_convenio_mesaño</b> <br>
                    -	vc indica que el archivo es de venta de cartera <br>
                    -	nit de la entidad <br>
                    -	convenio: código del convenio o modelo al que pertenece la operación <br>
                    -	mesaño mes del año de dos dígitos seguido del año completo de cuatro dígitos <br>
                <b>2. Formato del archivo:</b> <br>
                    -	El archivo solo podrá tener el formato TXT (texto plano) <br>
                    -	Ejemplo: vc_nit_convenio_062012.txt <br>
                <b>3. Formato fecha:</b> <br>
                    -	El formato de las fechas debe ser el siguiente (AAAA-MM-DD)`,
      tipo_archivo: "",
      multiple: false,
      perPage: 25,
      dataPendientes: [],
      dataLength: 0,
      sending: [],
      disponible: null,
      comprador: null,
      bancos: [],
      modalidad: null,
      productos: [],
      productos_disponibles: [],
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
    }),
    sending_filtered: function () {
      switch (this.sendingType) {
        case "erroneos":
          return this.sending.filter((sent) => sent.error == true);
          break;
        case "buenos":
          return this.sending.filter((sent) => sent.success == true);
          break;
        case "todos":
        default:
          return this.sending;
          break;
      }
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    limpiarInputReset() {
      this.$refs.archivo.reset();
    },
    fileChange(fileList) {
      this.files.append(
        "cargues[]",
        this.$refs["archivo"].$refs.input.files[0]
      );
    },
    async cargue() {
      this.$store.commit("SET_LOADING", true);

      const files = this.$refs["archivo"].$refs.input.files;

      this.sending = [];
      for (var i = 0; i < files.length; i++) {
        this.sending[i] = {
          name: files[i].name,
          progress: 0,
          errors: [],
          success: false,
          error: false,
        };
      }

      let errorCounter = 0;
      let errorLimit = 10;

      for (var i = 0; i < files.length; i++) {
        this.files = new FormData();

        this.productos.forEach((valor) => {
          if (valor.transf) {
            this.productos_disponibles.push({
              sig_producto_id: valor.sig_producto_id,
              disponible: valor.transf,
            });
          }
        });

        this.files.append("cargues[]", files[i]);
        this.files.append(
          "disponible",
          JSON.stringify(this.productos_disponibles)
        );
        this.files.append("comprador", this.comprador);
        this.files.append("modalidad", this.modalidad);

        let upload = new Promise((res, rej) => {
          this.$store.getters.api
            .post(
              this.informeCarga
                ? this.informeCarga.endpoint
                  ? this.informeCarga.endpoint
                  : "portal"
                : "portal",
              this.files
            )
            .then((response) => {
              res(response);
            })
            .catch((error) => {
              rej(error);
            });
        });

        upload
          .then((response) => {
            this.files = new FormData();
            this.uploadResponse = response.data;
            this.showDismissibleAlertSuccess = true;
            this.disponible = null;
            this.productos_disponibles = [];
            this.limpiarInputReset();
          })
          .catch((error) => {
            this.uploadRespnseError = error.response.data;
            this.showDismissibleAlertError = true;
          })
          .then(() => {
            this.$store.commit("SET_LOADING", false);
          });
      }
    },
    async abrirDisponible() {
      this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");
    },
    async guardarDisponible() {
      try {
        const formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
        });
        this.disponible = null;
        this.productos.forEach((value) => {
          if (value.transf) {
            value.transf = Math.trunc(value.transf);
            if (value.transf <= value.disponible) {
              this.disponible =
                (this.disponible ? +this.disponible : +0) + +value.transf;
            } else {
              this.$toasted.show(
                "El valor " +
                  value.transf +
                  " supera el disponible para el producto " +
                  (value.producto ? value.producto : value.alias),
                {
                  theme: "toasted-primary",
                  position: "top-right",
                  duration: 5000,
                }
              );
              value.transf = null;
            }
          }
        });
        this.disponible = formatter.format(this.disponible);
      } catch {
        this.$toasted.show("Ocurrio un error al guardar los datos", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        });
      }
      this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");
    },
  },
  async mounted() {
    this.$store.commit("SET_LOADING", true);
    try {
      let in_bancos = [];
      let configuracion = await this.$store.getters.api.get(
        "/configuracion_venta_cartera",
        {
          params: {
            paginar: false,
            sig_banco_id: this.$store.state.user.user.sig_banco_id,
          },
        }
      );

      this.bancos = configuracion.data.datos_bancos;

    } catch (err) {
      this.$toasted.show("Ocurrió un error cargando la configuración", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 5000,
      });
    }

    try {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
      });
      if (this.productos.length == 0) {
        let response = await this.$store.getters.api.get(
          "/disponible/productos/portal"
        );
        response.data.forEach((element, key) => {
          response.data[key].disponible_format = formatter.format(
            element.disponible
          );
        });

        this.productos = response.data;
        this.modal_disponible = true;
      }
    } catch {
      this.$toasted.show(
        "Ocurrió un error intentando consultar los productos",
        {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        }
      );
    }

    this.$store.commit("SET_LOADING", false);
  },
};
</script>
